export default __webpack_public_path__ + "static/media/slack.b371262c.gif";